// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2qpwd","additionalInfo":"AgreementModal_additionalInfo__1otRl"};